// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  border-top: 1px solid #F3F3F3;
}
.pagination-container .pagination-wrapper .ellipsis,
.pagination-container .pagination-wrapper .pagination-button {
  width: 40px;
  height: 40px;
}
.pagination-container .pagination-wrapper .pagination-button-wrapper.selected .pagination-button {
  background: #FFF2F2;
  color: #FF2459;
}
.pagination-container .previous-btn,
.pagination-container .next-btn {
  height: 36px !important;
}

.table-header-container .table-search-input .input-field,
.table-header-container .sort-button {
  height: 40px !important;
}
.table-header-container .menu-wrapper {
  min-width: 175px;
}

.table-container .table-wrapper {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border: 1px solid #F3F3F3;
}
.table-container table {
  width: 100%;
  display: flex;
  flex-flow: column;
  min-height: 400px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.table-container table th {
  position: sticky;
  top: 0;
  background: #F3F3F3;
}
.table-container table thead {
  border-bottom: 1px solid #E7E7E7;
  flex: 0 0 auto;
}
.table-container table tr {
  border-bottom: 1px solid #F3F3F3;
  width: 100%;
  display: table;
  table-layout: fixed;
}
.table-container table tbody {
  flex: 1 1 auto;
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
}
.table-container table td:has(.row-container.action-items-list),
.table-container table th:has(.column-header.action_items),
.table-container table .column-header.action_items,
.table-container table .row-container.action-items-list {
  width: 70px;
}
.table-container .header-data {
  text-align: left;
  padding: 16px 24px;
}
.table-container .header-data:first-of-type {
  border-top-left-radius: 12px;
}
.table-container .header-data:last-of-type {
  border-top-right-radius: 12px;
}
.table-container .row-container {
  padding: 16px 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/table/components/style.scss"],"names":[],"mappings":"AACA;EACE,6BAAA;AAAF;AAGI;;EAEE,WAAA;EACA,YAAA;AADN;AAKM;EACE,mBAAA;EACA,cAAA;AAHR;AAQE;;EAEE,uBAAA;AANJ;;AAWE;;EAEE,uBAAA;AARJ;AAWE;EACE,gBAAA;AATJ;;AAcE;EACE,4BAAA;EACA,6BAAA;EACA,yBAAA;AAXJ;AAcE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;AAZJ;AAcI;EACE,gBAAA;EACA,MAAA;EACA,mBAAA;AAZN;AAeI;EACE,gCAAA;EACA,cAAA;AAbN;AAgBI;EACE,gCAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AAdN;AAiBI;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAfN;AAkBI;;;;EAIE,WAAA;AAhBN;AAoBE;EACE,gBAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,4BAAA;AAlBN;AAqBI;EACE,6BAAA;AAnBN;AAuBE;EACE,kBAAA;AArBJ","sourcesContent":["\n.pagination-container {\n  border-top: 1px solid theme('colors.grey-10');\n\n  .pagination-wrapper {\n    .ellipsis,\n    .pagination-button {\n      width: 40px;\n      height: 40px;\n    }\n  \n    .pagination-button-wrapper.selected {\n      .pagination-button {\n        background: theme('colors.light');\n        color: theme('colors.primary')\n      }\n    }\n  }\n\n  .previous-btn,\n  .next-btn {\n    height: 36px !important;\n  }\n}\n\n.table-header-container {\n  .table-search-input .input-field,\n  .sort-button {\n    height: 40px !important;\n  }\n\n  .menu-wrapper {\n    min-width: 175px;\n  }\n}\n\n.table-container {\n  .table-wrapper {\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    border: 1px solid theme('colors.grey-10');\n  }\n\n  table {\n    width: 100%;\n    display: flex;\n    flex-flow: column;\n    min-height: 400px;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n\n    th {\n      position: sticky;\n      top: 0;\n      background: theme('colors.grey-10');\n    }\n\n    thead {\n      border-bottom: 1px solid theme('colors.grey-30');\n      flex: 0 0 auto;\n    }\n\n    tr {\n      border-bottom: 1px solid theme('colors.grey-10');\n      width: 100%;\n      display: table;\n      table-layout: fixed;\n    }\n\n    tbody {\n      flex: 1 1 auto;\n      display: block;\n      overflow-y: auto;\n      overflow-x: hidden;\n    }\n\n    td:has(.row-container.action-items-list),\n    th:has(.column-header.action_items),\n    .column-header.action_items,\n    .row-container.action-items-list {\n      width: 70px;\n    }\n  }\n\n  .header-data {\n    text-align: left;\n    padding: 16px 24px;\n\n    &:first-of-type {\n      border-top-left-radius: 12px;\n    }\n\n    &:last-of-type {\n      border-top-right-radius: 12px;\n    }\n  }\n\n  .row-container {\n    padding: 16px 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
